export const DynamicFormConstants = {
    
    DYNAMIC_FORM_REQUEST : 'DYNAMIC_FORM_REQUEST',
    DYNAMIC_FORM_SUCCESS : 'DYNAMIC_FORM_SUCCESS',
    DYNAMIC_FORM_FAILIURE : 'DYNAMIC_FORM_FAILIURE',

    GET_ALL_DYNAMIC_FORM_REQUEST : 'GET_ALL_DYNAMIC_FORM_REQUEST',
    GET_ALL_DYNAMIC_FORM_SUCCESS : 'GET_ALL_DYNAMIC_FORM_SUCCESS',
    GET_ALL_DYNAMIC_FORM_FAILIURE : 'GET_ALL_DYNAMIC_FORM_FAILIURE',

    GET_DYNAMIC_FORM_BY_ID_REQUEST : 'GET_DYNAMIC_FORM_BY_ID_REQUEST',
    GET_DYNAMIC_FORM_BY_ID_SUCCESS : 'GET_DYNAMIC_FORM_BY_ID_SUCCESS',
    GET_DYNAMIC_FORM_BY_ID_FAILIURE : 'GET_DYNAMIC_FORM_BY_ID_FAILIURE',

    GET_ACTIVE_DYNAMIC_FORM_REQUEST : 'GET_ACTIVE_DYNAMIC_FORM_REQUEST',
    GET_ACTIVE_DYNAMIC_FORM_SUCCESS : 'GET_ACTIVE_DYNAMIC_FORM_SUCCESS',
    GET_ACTIVE_DYNAMIC_FORM_FAILIURE : 'GET_ACTIVE_DYNAMIC_FORM_FAILIURE',
    CLEAR_ALL_DYNAMIC_FORM:'CLEAR_ALL_DYNAMIC_FORM',

};